// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import axios from '../Axiosinstance';
// import { CLOUDINARY_UPLOAD_PRESET, baseURL, timestamp } from '../common';
// import { toast, ToastContainer } from 'react-toastify';
// import { Button, Grid } from '@mui/material';
// import dayjs from 'dayjs';
// import Visibility from '@mui/icons-material/Visibility';
// import VisibilityOff from '@mui/icons-material/VisibilityOff';
// import { IconButton, InputAdornment, TextField, Select, FormControl, InputLabel, MenuItem } from '@mui/material'

// const NewStudent = ({ onFormSubmit }) => {
//   const navigate = useNavigate();
//   const [selectedFile, setSelectedFile] = useState(null);
//   const [uploadedFileUrl, setUploadedFileUrl] = useState('');
//   const [showEmploymentFields, setShowEmploymentFields] = useState(false);
//   const [courses, setCourses] = useState([]);
//   const [profileFile, setProfileFile] = useState(null);
//   const [nricFile, setNricFile] = useState(null);
//   const [educationFile, setEducationFile] = useState(null);
//   const [passportFile, setPassportFile] = useState(null);
//   const [isUploading, setIsUploading] = useState(false);
//   const CLOUDINARY_URL = baseURL;
//   const CLOUDINARY_UPLOAD = CLOUDINARY_UPLOAD_PRESET;
//   const [batches, setBatches] = useState([]);
//   const [showPassword, setShowPassword] = useState(false);
//   const [initialModulus, setInitialModulus] = useState(1)
//   const [selectedBatch, setSelectedBatch] = useState(null)
//   const [editFormData, setEditFormData] = useState({});
//   const genderOptions = ["Male", "Female", "Other"];
//   const [studentData, setStudentData] = useState({
//     name: '',
//     nric: '',
//     email: '',
//     phone: '',
//     gender: '',
//     dob: '',
//     password: '',
//     officephone: '',
//     address: '',
//     course: '',
//     citizenship: '',
//     postalcode: '',
//     race: '',
//     education: '',
//     employmentstatus: '',

//     salary: '',
//     companyname: '',
//     designation: '',
//     profileUrl: '',
//     batchId: null,
//     startModulus: null,
//     status: false,
//     passport: '',
//     passportExpiryDate: '',
//     fatherName: '',
//     martialStatus: '',
//     brotherName: '',
//     fatherPhoneNo: '',
//     brotherPhoneNo: '',
//     religion: '',
//     currentAddress: '',
//     institutionDetails: [],
//     workExpirences: [],
//     nricdoc: '',
//     educationdoc: '',
//     passportdoc: '',
//     type: "",
//     customId: "",
//     durationType: "",
//     relationship: "",
//     proofType: "",
//   });

//   const togglePasswordVisibility = () => {
//     setShowPassword(!showPassword); // Toggle the visibility of the password
//   };


//   useEffect(() => {
//     const fetchBatches = async () => {
//       try {
//         const response = await axios.get("batch-summary"); // API endpoint to get batches
//         setBatches(response.data);
//       } catch (error) {
//         console.error("Error fetching batches:", error);
//       }
//     };

//     fetchBatches();
//   }, []);

//   const [errors, setErrors] = useState({
//     fullname: "",
//     fatherName: "",
//     brotherName: "",
//     // course: "",
//     religion: "",
//     citizenship: "",
//     nric: "",
//     brotherPhoneNo: "",
//     officephone: "",
//     fatherPhoneNo: "",
//   });

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     console.log(name, value);
//     // const nricRegex = /^[A-Z]\d{7}[A-Z]$/;

//     // Regex to allow only letters and spaces
//     const lettersOnlyRegex = /^[a-zA-Z\s]*$/;

//     // Regex to allow only numbers
//     const onlyNumberRegex = /^[0-9]*$/;

//     let errorMessage = "";

//     // Check if the field is a text-only field and validate
//     if ((name === "fullname" || name === "fatherName" || name === "religion" || name === "citizenship") && !lettersOnlyRegex.test(value)) {
//       errorMessage = "Only letters are allowed.";
//     }

//     // if (name === "nric" && value.length === 9 && !nricRegex.test(value)) {
//     //   errorMessage = "NRIC must be in the format: 1 capital letter, 7 digits, 1 capital letter (e.g., K1234567H).";
//     // }

//     if ((name === "fatherPhoneNo" || name === "officephone") && !onlyNumberRegex.test(value)) {
//       errorMessage = "Only numbers are allowed.";
//     }

//     if (name === "passportExpiryDate") {
//       // Extract the year from the date input
//       const year = value.split("-")[0];

//       // Check if the year is more than 4 digits
//       if (year.length > 4) {
//         errorMessage = "Year cannot be more than 4 digits.";
//       }
//     }
//     if (name === "dob") {
//       // Extract the year from the date input
//       const year = value.split("-")[0];

//       // Check if the year is more than 4 digits
//       if (year.length > 4) {
//         errorMessage = "Year cannot be more than 4 digits.";
//       }
//     }

//     // Update the error state
//     setErrors((prevErrors) => ({
//       ...prevErrors,
//       [name]: errorMessage,
//     }));

//     // Update student data only if validation passes
//     if (!errorMessage) {
//       if (name === "nric") {
//         setStudentData((prevData) => ({
//           ...prevData,
//           nric: value,
//           password: value, // Assign NRIC value as password
//         }));
//       } else {
//         setStudentData((prevData) => ({
//           ...prevData,
//           [name]: value,
//         }));
//       }
//     }

//     if (name === "course") {
//       // Find the selected batch details
//       const selectedBatch = batches.find((batch) => batch.course === value);
//       setSelectedBatch(selectedBatch);
//       setInitialModulus(selectedBatch?.currentModule);
//       // Update studentData with course, batchId, and currentModule
//       setStudentData((prevData) => ({
//         ...prevData,
//         course: value, // Selected course name
//         batchId: selectedBatch?.id || null, // Selected batchId
//         startModulus: selectedBatch?.currentModule || null, // Selected currentModule
//         enrollmentDate: "", // Reset enrollment date
//       }));
//     } else if (!errorMessage) {
//       // Update student data only if validation passes
//       setStudentData({
//         ...studentData,
//         [name]: value,
//       });
//     }
//   };



//   //for nric and email
//   const handleNricEmailChange = async (e) => {
//     const { name, value } = e.target;

//     // Update both nric and password if editing nric
//     setStudentData((prev) => ({
//       ...prev,
//       [name]: value,
//       ...(name === "nric" && { password: value }) // this sets password = value only if name === "nric"
//     }));

//     const trimmedValue = value.trim();

//     if (name === "nric") {
//       const nricRegex = /^[STFGM]\d{7}[A-Z]$/;

//       if (!nricRegex.test(trimmedValue)) {
//         setErrors((prev) => ({
//           ...prev,
//           nric: "Invalid NRIC/FIN format. Format: S1234567A",
//         }));
//         return;
//       } else {
//         setErrors((prev) => ({ ...prev, nric: "" }));
//       }
//     }

//     if (trimmedValue !== "") {
//       try {
//         const response = await axios.get(`/registrationadvances/exists?${name}=${value}`);
//         if (response.data) {
//           setErrors((prev) => ({
//             ...prev,
//             [name]: `${name.toUpperCase()} already exists!`,
//           }));
//         } else {
//           setErrors((prev) => ({ ...prev, [name]: "" }));
//         }
//       } catch (error) {
//         console.error(`Error checking ${name}:`, error);
//         setErrors((prev) => ({
//           ...prev,
//           [name]: `Error checking ${name}. Try again!`,
//         }));
//       }
//     } else {
//       setErrors((prev) => ({ ...prev, [name]: "" }));
//     }
//   };





//   const handleFileChange = (setFile, allowedTypes, fieldName, allowedFormatsText) => (event) => {
//     const file = event.target.files[0];
//     if (!file) return;

//     if (file.size > 8 * 1024 * 1024) {
//       event.target.value = "";
//       toast.error("Max file size 8MB");
//       return;
//     }

//     if (!allowedTypes.includes(file.type)) {
//       event.target.value = "";
//       toast.error(`${fieldName}: Only ${allowedFormatsText}`);
//       return;
//     }

//     setFile(file);
//   };
//   // const uploadFile = async (file, folderPath) => {
//   //   const formData = new FormData();
//   //   formData.append('file', file);
//   //   formData.append('upload_preset', CLOUDINARY_UPLOAD_PRESET);
//   //   formData.append('public_id', folderPath);

//   //   const response = await fetch(baseURL, {
//   //     method: 'POST',
//   //     body: formData,
//   //   });

//   //   const data = await response.json();
//   //   if (!data.secure_url) {
//   //     throw new Error('Failed to upload file.');
//   //   }
//   //   return data.secure_url;
//   // };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     // Check if any error messages exist in the errors state
//     if (Object.keys(errors).length > 0 && Object.values(errors).some((error) => error.trim() !== "")) {
//       toast.error("Please resolve all validation errors before submitting.");
//       return;
//     }

//     try {
//       setIsUploading(true); // Set uploading state to true
//       let profileUrl = "";
//       let nricdoc = "";
//       let passportdoc = "";
//       let educationdoc = "";
//       const offerDate = studentData.enrollmentDate;

//       // Upload the files
//       const uploadFile = async (file) => {
//         if (file) {
//           const formData = new FormData();
//           formData.append("file", file);
//           formData.append("upload_preset", CLOUDINARY_UPLOAD_PRESET);
//           formData.append("public_id", `LMS/${file.name} +' - '+ ${timestamp}`);

//           const response = await fetch(baseURL, {
//             method: "POST",
//             body: formData,
//           });

//           const data = await response.json();
//           if (data.secure_url) {
//             return data.secure_url;
//           } else {
//             throw new Error("Failed to upload file.");
//           }
//         }
//         return "";
//       };

//       profileUrl = await uploadFile(profileFile);
//       nricdoc = await uploadFile(nricFile);
//       passportdoc = await uploadFile(passportFile);
//       educationdoc = await uploadFile(educationFile);

//       // Update student data with the uploaded URLs
//       const updatedStudentData = {
//         ...studentData,
//         profileUrl,
//         nricdoc,
//         passportdoc,
//         educationdoc,
//         offerDate,
//       };

//       // Submit the student data
//       const studentResponse = await axios.post("registrationadvances", updatedStudentData);
//       console.log("Student data submitted successfully:", studentResponse.data);

//       toast.success("Student added successfully");
//       // window.location.reload();
//       onFormSubmit();
//     } catch (error) {
//       console.error("Error submitting student data:", error);
//       toast.error("Failed to submit student data. Please try again.");
//     } finally {
//       setIsUploading(false); // Set uploading state to false after the process
//     }
//   };
//   //hwdgh

//   const handleInstitutionChange = (index, e) => {
//     const { name, value } = e.target;

//     const newInstitutionDetails = studentData.institutionDetails.map((institution, i) => {
//       if (i === index) {
//         const updatedInstitution = { ...institution, [name]: value };

//         // Convert both fields to integers for validation
//         const fromYear = parseInt(updatedInstitution.fromYear);
//         const toYear = parseInt(updatedInstitution.toYear);

//         // Validate only if both years have 4 digits
//         if (
//           !isNaN(fromYear) &&
//           !isNaN(toYear) &&
//           updatedInstitution.fromYear.length === 4 &&
//           updatedInstitution.toYear.length === 4
//         ) {
//           if (fromYear > toYear) {
//             toast.error("From Year cannot be greater than To Year");
//           }
//         }

//         return updatedInstitution;
//       }
//       return institution;
//     });

//     setStudentData({ ...studentData, institutionDetails: newInstitutionDetails });
//   };

//   const handleAddEducation = () => {
//     setStudentData({
//       ...studentData,
//       institutionDetails: [
//         ...studentData.institutionDetails,
//         { institution: '', toYear: '', fromYear: '', qualificationsAchieved: '', country: '', educationCertificateNo: '', },
//       ],
//     });
//   };

//   const handleRemoveEducation = (index) => {
//     const newInstitutionDetails = studentData.institutionDetails.filter((_, i) => i !== index);
//     setStudentData({ ...studentData, institutionDetails: newInstitutionDetails });
//   };


//   const handleWorkExperienceChange = (index, e) => {
//     const { name, value } = e.target;

//     const newWorkExperiences = studentData.workExpirences.map((experience, i) => {
//       if (i === index) {
//         const updatedExperience = { ...experience, [name]: value };

//         const fromYear = parseInt(updatedExperience.fromYear);
//         const toYear = parseInt(updatedExperience.toYear);

//         // Validate only if both years have 4 digits
//         if (
//           !isNaN(fromYear) &&
//           !isNaN(toYear) &&
//           updatedExperience.fromYear.length === 4 &&
//           updatedExperience.toYear.length === 4
//         ) {
//           if (fromYear > toYear) {
//             toast.error("From Year cannot be greater than To Year in Work Experience");
//           }
//         }

//         return updatedExperience;
//       }
//       return experience;
//     });

//     setStudentData({
//       ...studentData,
//       workExpirences: newWorkExperiences
//     });
//   };

//   const handleAddWorkExperience = () => {
//     setStudentData((prevState) => ({
//       ...prevState,
//       workExpirences: [
//         ...prevState.workExpirences,
//         { name: '', position: '', toYear: '', fromYear: '', country: '' }
//       ]
//     }));
//     setShowEmploymentFields(true); // Show employment fields after adding
//   };

//   const handleRemoveWorkExperience = (index) => {
//     const newWorkExperiences = studentData.workExpirences.filter((_, i) => i !== index);
//     setStudentData({
//       ...studentData,
//       workExpirences: newWorkExperiences
//     });
//     if (newWorkExperiences.length === 0) {
//       setShowEmploymentFields(false); // Hide employment fields if no experience entries
//     }
//   };
//   const dayMapping = {
//     'Sunday': 0,
//     'Monday': 1,
//     'Tuesday': 2,
//     'Wednesday': 3,
//     'Thursday': 4,
//     'Friday': 5,
//     'Saturday': 6
//   };

//   const handleDateChange = (event) => {
//     // Get the new date from the event
//     const { value } = event.target;
//     console.log("Selected Enrollment Date:", value);
//     console.log("Selected Date:", selectedBatch);

//     const newDate = dayjs(value);
//     const currentDate = dayjs();

//     const intakeStartDate = selectedBatch?.intakeStartDate ? dayjs(selectedBatch.intakeStartDate) : null;
//     const isDatePassed = intakeStartDate && newDate.isAfter(intakeStartDate);

//     if (selectedBatch?.status && newDate.isBefore(currentDate, 'day') && intakeStartDate) {
//       toast.error("Enrollment date cannot be before today.");
//       return;
//     } else if (selectedBatch?.status && isDatePassed) {
//       toast.error("Batch is not started yet.");
//       return;
//     } else if (selectedBatch?.status && !isDatePassed) {
//       // If batch status is true, use current module and skip calculations
//       setStudentData((prevStudentData) => ({
//         ...prevStudentData,
//         enrollmentDate: value,
//         startModulus: selectedBatch?.currentModule,
//       }));

//       console.log("Batch is active. Using current module:", selectedBatch?.currentModule);
//       return; // Exit function
//     }

//     const oldDate = dayjs();

//     console.log("Current Date:", oldDate.format('YYYY-MM-DD'));
//     console.log("New Date:", newDate.format('YYYY-MM-DD'));
//     console.log("New Date Valid?", newDate.isValid());

//     // Check for invalid date handling
//     if (!newDate.isValid()) {
//       console.error("Invalid newDate detected. Check input format.");
//       return;
//     }

//     let monthDifference = newDate.month() - oldDate.month();
//     if (newDate.year() !== oldDate.year()) {
//       monthDifference += (newDate.year() - oldDate.year()) * 12;
//     }
//     console.log("Month Difference:", monthDifference);

//     console.log("Form Data Type:", studentData?.type);

//     let increment = 0;
//     if (studentData?.type === 'diploma') {
//       // Check if the oldDate month is odd or even
//       if (oldDate.month() % 2 === 1) {
//         // For odd months, increment by 1 for every odd month difference
//         increment = Math.floor((monthDifference + 1) / 2);
//       } else {
//         // For even months, increment by 1 for every 2 months
//         increment = Math.floor(monthDifference / 2);
//       }
//       console.log("Diploma Course - Increment:", increment);
//     } else if (studentData?.type === 'advance_diploma') {
//       // For advance diploma, increment by the full month difference
//       increment = monthDifference;
//       console.log("Advance Diploma Course - Increment:", increment);
//     } else {
//       console.warn("Unknown formData.type detected:", studentData?.type);
//     }

//     console.log("Initial Modulus:", initialModulus);

//     // Adjust the modulus based on the increment
//     let newModulus = initialModulus + increment;
//     newModulus = ((newModulus - 1) % 6 + 6) % 6 + 1; // Ensure modulus stays within 1-6
//     console.log("New Modulus After Adjustments:", newModulus);

//     // Get the first day object from selectedBatch.days (e.g., [{ day: "Saturday" }])
//     const firstDay = selectedBatch?.days?.[0];
//     const dayIndex = dayMapping[firstDay?.day]; // Fallback to Sunday if missing

//     // Calculate first occurrence of the specified weekday
//     const firstOfMonth = newDate.date(1);
//     let firstSpecifiedDay = firstOfMonth.day(dayIndex);

//     if (firstSpecifiedDay.isBefore(firstOfMonth)) {
//       firstSpecifiedDay = firstSpecifiedDay.add(1, 'week');
//     }

//     console.log("First Specified Day of the Month:", firstSpecifiedDay.format('YYYY-MM-DD'));

//     console.log("before updating  New Modulus:", newModulus);

//     if (studentData?.type === 'diploma') {
//       const isEvenMonth = (newDate.month() + 1) % 2 === 0;
//       console.log("Is Even Month:", isEvenMonth);

//       if (isEvenMonth) {
//         newModulus += 1;
//         console.log("Diploma - Even Month: Adjusting Modulus by adding 1.");
//       } else {
//         if (newDate.isAfter(firstSpecifiedDay)) {
//           newModulus += 1;
//           console.log("Diploma - Odd Month: Adjusting Modulus by adding 1 after first Saturday/Sunday.");
//         }
//       }
//     }
//     else if (studentData?.type === 'advance_diploma') {

//       console.log((oldDate.month()), "oldDate");
//       console.log((oldDate.month() + 1) % 2, "oldDate");
//       if ((oldDate.month() + 1) % 2 === 1) {
//         // For odd months, increment by 1 for every odd month difference
//         if (newDate.isAfter(firstSpecifiedDay)) {
//           newModulus = newModulus;
//           console.log("Advance Diploma - Adjusting Modulus by subtracting 1.", (oldDate.month()));
//         }
//         else {
//           newModulus -= 1;
//         }
//       }



//       else if ((oldDate.month() + 1) % 2 === 0) {
//         if (newDate.isAfter(firstSpecifiedDay)) {
//           newModulus += 1;
//           console.log("Advance Diploma - Adjusting Modulus by adding 1.", (oldDate.month()));

//         }
//         else {
//           newModulus = newModulus;
//           console.log("hiihih", (oldDate.month()));
//         }
//       }

//     }

//     newModulus = ((newModulus - 1) % 6 + 6) % 6 + 1;
//     console.log("Final New Modulus:", newModulus);

//     setStudentData(prevStudentData => ({
//       ...prevStudentData,
//       enrollmentDate: value,
//       startModulus: newModulus,
//     }));

//     console.log("Updated Form Data:", {
//       ...setStudentData,
//       enrollmentDate: value,
//       startModulus: newModulus,
//     });
//   };

//   // const handleCourseTypeChange = (e) => {
//   //   setStudentData({ ...studentData, type: e.target.value });
//   // };

//   // const handleCourseDurationTypeChange = (e) => {
//   //   setStudentData({ ...studentData, durationType: e.target.value });
//   // };

//   // const toastId = 'no-course-toast';

//   // const filteredBatches = batches.filter(
//   //   (batch) =>
//   //     batch.type === studentData.type &&
//   //     batch.durationType === studentData.durationType
//   // );

//   // if (filteredBatches.length === 0 && studentData.type && studentData.durationType) {
//   //   if (!toast.isActive(toastId)) {
//   //     toast.warning('No courses available for the selected Course Type and Duration Type!', {
//   //       toastId: toastId,
//   //     });
//   //   }
//   // }

//   return (

//     <div className="containerw mx-auto " style={{ maxWidth: '1200px', background: '#ffffff', padding: '20px', boxShadow: '0px 0px 2px 0px #000000', borderRadius: '10px', marginTop: '1%' }
//     }>





//       <h4>New Student(AEG International College) </h4>
//       < hr style={{ marginTop: '1%' }} />


//       < form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'row' }} >

//         <div style={{ marginRight: '20px', flex: 1 }}>
//           <div className="form-grup" >
//             <label htmlFor="name" > Name * </label>
//             < input
//               type="text"
//               style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}
//               id="name"
//               className="form-control"
//               name="name"
//               value={studentData.name}
//               onChange={handleChange}
//               required
//             />
//             {errors.fullname && <p style={{ color: "red" }}> {errors.fullname} </p>}
//           </div>



//           <div className="form-group" style={{ marginTop: '10px' }}>
//             <label htmlFor="proofType"> Proof Type* </label>
//             <select
//               id="proofType"
//               className="form-control"
//               name="proofType"
//               value={studentData.proofType || ""}
//               onChange={handleChange}
//               required
//               style={{ width: '100%', height: '48px', borderRadius: '6px', border: '1px solid #ced4da' }}
//             >
//               <option value=""> Select Proof Type </option>
//               <option value="NRIC"> NRIC</option>
//               <option value="FIN"> FIN</option>
//             </select>
//             {/* {errors.durationType && <p style={{ color: "red" }}>{errors.durationType}</p>} */}
//           </div>

//           < div className="form-group" >
//             <label htmlFor="nric" > NRIC / FIN No * </label>
//             < input
//               type="text"
//               style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}
//               id="nric"
//               className="form-control"
//               name="nric"
//               value={studentData.nric && studentData.password || ""} // Ensure value is controlled
//               onChange={handleNricEmailChange}
//               required
//               maxLength={9}
//             />
//             {errors.nric && <p style={{ color: "red", fontSize: "0.87rem" }}> {errors.nric} </p>}
//           </div>

//           < div className="form-group" >
//             <label htmlFor="email" > Email * </label>
//             < input
//               type="email"
//               style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}
//               id="email"
//               className="form-control"
//               name="email"
//               value={studentData.email}
//               onChange={handleNricEmailChange}
//               required
//               maxLength={100}
//             />
//             {errors.email && <p style={{ color: "red" }}> {errors.email} </p>}
//           </div>

//           < div className="form-group" >

//             <label htmlFor="name" > Passport Number * </label>
//             < input
//               type="text"
//               style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}
//               id="passport"
//               className="form-control"
//               name="passport"
//               value={studentData.passport}
//               onChange={handleChange}
//               maxLength={8}

//             />
//           </div>

//           {/* < div className="form-group" >

//             <label htmlFor="name" > Student ID * </label>
//             < input
//               type="text"
//               style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}
//               id="customId"
//               className="form-control"
//               name="customId"
//               // value={studentData.passport}
//               onChange={handleChange}
//               maxLength={20}

//             />
//           </div> */}


//           < div className="form-group" >

//             <label htmlFor="name" > Passport ExpiryDate * </label>
//             < input
//               type="date"
//               style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}
//               id="passportExpiryDate"
//               className="form-control"
//               name="passportExpiryDate"
//               value={studentData.passportExpiryDate}
//               onChange={handleChange}
//               required
//             />
//           </div>


//           {/* Diploma / Advanced Diploma Dropdown */}
//           {/* <div className="form-group" style={{ marginTop: '10px' }}>
//             <label htmlFor="type"> Course Type * </label>
//             <select
//               id="type"
//               className="form-control"
//               name="type"
//               value={studentData.type || ""}
//               onChange={handleCourseTypeChange}
//               required
//               style={{ width: '100%', height: '48px', borderRadius: '6px', border: '1px solid #ced4da' }}
//             >
//               <option value=""> Select Course Type </option>
//               <option value="diploma"> Diploma </option>
//               <option value="advance_diploma"> Advanced Diploma </option>
//             </select>
//             {errors.type && <p style={{ color: "red" }}>{errors.type}</p>}
//           </div> */}


//           <div className="form-group" style={{ marginTop: '10px' }}>
//             <label htmlFor="durationType"> Duration Type * </label>
//             <select
//               id="durationType"
//               className="form-control"
//               name="durationType"
//               value={studentData.durationType || ""}
//               onChange={handleChange}
//               required
//               style={{ width: '100%', height: '48px', borderRadius: '6px', border: '1px solid #ced4da' }}
//             >
//               <option value=""> Select Course Type </option>
//               <option value="part_time"> Part Time </option>
//               <option value="full_time"> Full Time </option>
//             </select>
//             {errors.durationType && <p style={{ color: "red" }}>{errors.durationType}</p>}
//           </div>


//           <div className="form-group">
//             <label htmlFor="course"> Course * </label>
//             <select
//               id="course"
//               className="form-control"
//               name="course"
//               value={studentData.course}
//               onChange={handleChange}
//               style={{ width: '100%', height: '46px', borderRadius: '6px', border: '1px solid #ced4da' }}
//               required
//             >
//               <option value=""> Select Course...</option>
//               {batches.map((batch) => (
//                 <option key={batch.id} value={batch.course}>
//                   {batch.course}
//                 </option>
//               ))}
//             </select>
//           </div>


//           {/* <div className="form-group" style={{ marginTop: '10px' }}>
//             <label htmlFor="Status"> Status </label>
//             <select
//               id="Status"
//               className="form-control"
//               name="Status"
//               value={studentData.Status || ""}
//               onChange={handleChange}
//               required
//               style={{ width: '100%', height: '48px', borderRadius: '6px', border: '1px solid #ced4da' }}
//             >
//               <option value=""> Select Status </option>
//               <option value="Active">Active </option>
//               <option value="Withdraw"> Withdraw </option>
//               <option value="Graduation"> Graduation </option>
//             </select>
//             {errors.Status && <p style={{ color: "red" }}>{errors.Status}</p>}
//           </div> */}



//           < div className="form-group" >

//             <label htmlFor="Enrollment Date" > Enrollment Date * </label>
//             < input
//               type="date"
//               style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}
//               id="enrollmentDate"
//               className="form-control"
//               name="enrollmentDate"
//               value={studentData.enrollmentDate || ""}
//               onChange={handleDateChange}
//               required
//               disabled={!studentData.course}
//               InputLabelProps={{ shrink: true }}
//             />
//           </div>

//           < div className="form-group" >
//             <label htmlFor="race" > Religion * </label>
//             < input
//               type="text"
//               id="race"
//               style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}

//               className="form-control"
//               name="religion"
//               value={studentData.religion}
//               onChange={handleChange}
//               required
//             />
//             {errors.religion && <p style={{ color: "red" }}> {errors.religion} </p>}
//           </div>



//           < div >
//             <Grid container spacing={2} justifyContent="center">
//               <Grid item xs={12} sm="auto">
//                 <Button
//                   type="button"
//                   variant="contained"
//                   onClick={handleAddEducation}
//                   fullWidth
//                   style={{ margin: '10px 4px' }}
//                 >
//                   + Add Education
//                 </Button>
//               </Grid>

//               <Grid item xs={12} sm="auto">
//                 <Button
//                   type="button"
//                   variant="contained"
//                   onClick={handleAddWorkExperience}
//                   fullWidth
//                   style={{ margin: '8px 6px' }}
//                 >
//                   + Add Employment
//                 </Button>
//               </Grid>
//             </Grid>

//             {
//               studentData.institutionDetails.map((institution, index) => (
//                 <div key={index} style={{ marginBottom: '15px', padding: '10px', border: '1px solid #ced4da', borderRadius: '6px' }}>
//                   <div className="form-group" >
//                     <label htmlFor={`institutionName-${index}`}> Institution Name * </label>
//                     < input
//                       type="text"
//                       id={`institutionName-${index}`}
//                       style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}
//                       className="form-control"
//                       name="institution"
//                       value={institution.institution}
//                       onChange={(e) => handleInstitutionChange(index, e)}
//                       required
//                     />
//                   </div>

//                   < div className="form-group" >
//                     <label htmlFor={`degree-${index}`}> Degree * </label>
//                     < input
//                       type="text"
//                       id={`degree-${index}`}
//                       style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}
//                       className="form-control"
//                       name="qualificationsAchieved"
//                       value={institution.qualificationsAchieved}
//                       onChange={(e) => handleInstitutionChange(index, e)}
//                       required
//                     />
//                   </div>

//                   {/* < div className="form-group" >
//                     <label htmlFor={`yearOfGraduation-${index}`}> Year of Graduation * </label>
//                     < input
//                       type="number"
//                       id={`yearOfGraduation-${index}`}
//                       style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}
//                       className="form-control"
//                       name="year"
//                       value={institution.year}
//                       onChange={(e) => handleInstitutionChange(index, e)}
//                       required
//                     />
//                   </div> */}

//                   {/* Country */}


//                   <div className="form-group">
//                     <label htmlFor={`country-${index}`}> Country * </label>
//                     <input
//                       type="text"
//                       id={`country-${index}`}
//                       style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}
//                       className="form-control"
//                       name="country"
//                       value={institution.country}
//                       onChange={(e) => handleInstitutionChange(index, e)}
//                       required
//                     />
//                   </div>

//                   {/* Education Certificate Number */}
//                   <div className="form-group">
//                     <label htmlFor={`educationCertificateNo-${index}`}> Certificate Number * </label>
//                     <input
//                       type="text"
//                       id={`educationCertificateNo-${index}`}
//                       style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}
//                       className="form-control"
//                       name="educationCertificateNo"
//                       value={institution.educationCertificateNo}
//                       onChange={(e) => handleInstitutionChange(index, e)}
//                       required
//                     />
//                   </div>

//                   {/* From Year */}
//                   <div className="form-group" style={{ display: 'flex', gap: '16px' }}>
//                     {/* From Year */}
//                     <div style={{ flex: 1 }}>
//                       <label htmlFor={`fromYear-${index}`}>From Year *</label>
//                       <input
//                         type="number"
//                         id={`fromYear-${index}`}
//                         className="form-control"
//                         name="fromYear"
//                         value={institution.fromYear}
//                         onChange={(e) => handleInstitutionChange(index, e)}
//                         style={{
//                           width: '100%',
//                           height: '42px',
//                           borderRadius: '6px',
//                           border: '1px solid #ced4da'
//                         }}
//                         required
//                       />
//                     </div>

//                     {/* To Year */}
//                     <div style={{ flex: 1 }}>
//                       <label htmlFor={`toYear-${index}`}>To Year *</label>
//                       <input
//                         type="number"
//                         id={`toYear-${index}`}
//                         className="form-control"
//                         name="toYear"
//                         value={institution.toYear}
//                         onChange={(e) => handleInstitutionChange(index, e)}
//                         style={{
//                           width: '100%',
//                           height: '42px',
//                           borderRadius: '6px',
//                           border: '1px solid #ced4da'
//                         }}
//                         required
//                       />
//                     </div>
//                   </div>




//                   < button
//                     type="button"
//                     onClick={() => handleRemoveEducation(index)}
//                     style={{
//                       margin: '10px 0',
//                       padding: '5px 15px',
//                       fontSize: '16px',
//                       backgroundColor: 'red',
//                       color: 'white',
//                       borderRadius: '8px',
//                       border: 'none',
//                       cursor: 'pointer',
//                       transition: 'background-color 0.3s ease',
//                       boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
//                     }}
//                   >
//                     Remove
//                   </button>
//                 </div>
//               ))}
//           </div>
//         </div>



//         < div style={{ flex: 1 }}>
//           < div className="form-group" >
//             <label htmlFor="citizen" > Citizenship * </label>
//             < input
//               type="text"
//               id="citizenship"
//               style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}

//               className="form-control"
//               name="citizenship"
//               value={studentData.citizenship}
//               onChange={handleChange}
//               required
//             />
//             {errors.citizenship && <p style={{ color: "red" }}> {errors.citizenship} </p>}
//           </div>

//           <div style={{ display: 'flex', gap: '10px' }}>
//             <div className="form-group" style={{ flex: 1 }}>
//               <label htmlFor="officephone">Office Phone</label>
//               <input
//                 type="tel"
//                 id="officephone"
//                 style={{
//                   width: '100%',
//                   height: '42px',
//                   borderRadius: '6px',
//                   border: '1px solid #ced4da',
//                 }}
//                 className="form-control"
//                 name="officephone"
//                 value={studentData.officephone}
//                 onChange={handleChange}
//                 onInput={(e) => {
//                   e.target.value = e.target.value.replace(/\D/g, '').slice(0, 10);
//                 }}
//               />
//               {errors.officephone && (
//                 <p style={{ color: 'red' }}>{errors.officephone}</p>
//               )}
//             </div>

//             <div className="form-group" style={{ flex: 1 }}>
//               <label htmlFor="phone">Hand Phone *</label>
//               <input
//                 type="tel"
//                 id="phone"
//                 style={{
//                   width: '100%',
//                   height: '42px',
//                   borderRadius: '6px',
//                   border: '1px solid #ced4da',
//                 }}
//                 className="form-control"
//                 name="phone"
//                 value={studentData.phone}
//                 onChange={handleChange}
//                 required
//                 onInput={(e) => {
//                   e.target.value = e.target.value.replace(/\D/g, '').slice(0, 10);
//                 }}
//               />
//               {errors.phone && <p style={{ color: 'red' }}>{errors.phone}</p>}
//             </div>
//           </div>

//           <div className="form-group" >
//             <label htmlFor="martialStatus"> Marital Status* </label>
//             <select
//               id="martialStatus"
//               className="form-control"
//               name="martialStatus"
//               value={studentData.martialStatus}
//               onChange={handleChange}
//               required
//             // style={{ width: '100%', height: '48px', borderRadius: '6px', border: '1px solid #ced4da' }}
//             >
//               <option value=""> Select Marital Status </option>
//               <option value="single"> Single </option>
//               <option value="married"> Married </option>
//               <option value="divorced"> Divorced </option>
//               <option value="widowed"> Widowed </option>
//             </select>
//             {/* {errors.maritalStatus && <p style={{ color: "red" }}>{errors.maritalStatus}</p>} */}
//           </div>





//           < div className="form-group" >
//             <label htmlFor="gender" > Gender * </label>
//             < select
//               id="gender"
//               style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}

//               className="form-control"
//               name="gender"
//               required
//               value={studentData.gender}
//               onChange={handleChange}
//             >
//               <option value="" > Select Gender </option>
//               {
//                 genderOptions.map((option) => (
//                   <option key={option} value={option} >
//                     {option}
//                   </option>
//                 ))
//               }
//             </select>
//           </div>

//           < div className="form-group" >
//             <label htmlFor="dob" > Date of Birth * </label>
//             < input
//               type="date"
//               id="dob"
//               style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}
//               className={`form-control`}
//               name="dob"
//               value={studentData.dob}
//               onChange={handleChange}
//               // max={formatDate(new Date())} // Set the max attribute to today's date
//               required
//             />
//           </div>


//           {/* <div className="form-group">
//             <label htmlFor="password">Password *</label>
//             <TextField
//               id="password"

//               variant="outlined"
//               type={showPassword ? 'text' : 'password'} // Toggle between text and password
//               name="password"
//               value={studentData.password}
//               onChange={handleChange}
//               required
//               fullWidth
//               InputProps={{
//                 endAdornment: (
//                   <InputAdornment position="end">
//                     <IconButton
//                       onClick={togglePasswordVisibility}
//                       edge="end"
//                       aria-label="toggle password visibility"
//                     >
//                       {showPassword ? <VisibilityOff /> : <Visibility />}
//                     </IconButton>
//                   </InputAdornment>
//                 ),
//               }}
//             />
//           </div> */}


//           < div className="form-group" >
//             <label htmlFor="address" > Home Address * </label>
//             < input
//               type="text"
//               id="address"
//               style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}

//               className="form-control"
//               name="address"
//               value={studentData.address}
//               onChange={handleChange}
//               required
//             />
//           </div>

//           < div className="form-group" >
//             <label htmlFor="address" > Singapore Address </label>
//             < input
//               type="text"
//               id="address"
//               style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}

//               className="form-control"
//               name="currentAddress"
//               value={studentData.currentAddress}
//               onChange={handleChange}
//             />
//           </div>

//           < div className="form-group" >
//             <label htmlFor="address" >Relationship *</label>
//             < input
//               required
//               type="text"
//               id="address"
//               style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}

//               className="form-control"
//               name="relationship"
//               value={studentData.relationship}
//               onChange={handleChange}
//             />
//           </div>
//           <div className="form-group" style={{ display: 'grid', gap: '6px', gridTemplateColumns: '1fr 1fr' }}>
//             <div>
//               <label htmlFor="fatherName">Emergency Contact Name</label>
//               <input
//                 type="text"
//                 id="fatherName"
//                 style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}
//                 className="form-control"
//                 name="fatherName"
//                 value={studentData.fatherName}
//                 onChange={handleChange}
//               />
//               {errors.fatherName && <p style={{ color: 'red' }}>{errors.fatherName}</p>}
//             </div>

//             <div>
//               <label htmlFor="fatherPhoneNo">Emergency Contact Number</label>
//               <input
//                 type="text"
//                 id="fatherPhoneNo"
//                 style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}
//                 className="form-control"
//                 name="fatherPhoneNo"
//                 value={studentData.fatherPhoneNo}
//                 onChange={handleChange}
//                 onInput={(e) => e.target.value = e.target.value.replace(/\D/g, '').slice(0, 10)}
//               />
//               {errors.fatherPhoneNo && <p style={{ color: 'red' }}>{errors.fatherPhoneNo}</p>}
//             </div>
//           </div>

//           {/* <div className="form-group" style={{ display: 'grid', gap: '6px', gridTemplateColumns: '1fr 1fr' }}>
//             <div>
//               <label htmlFor="brotherName">Brother Name</label>
//               <input
//                 type="text"
//                 id="brotherName"
//                 style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}
//                 className="form-control"
//                 name="brotherName"
//                 value={studentData.brotherName}
//                 onChange={handleChange}
//               />
//               {errors.brotherName && <p style={{ color: 'red' }}>{errors.brotherName}</p>}
//             </div>

//             <div>
//               <label htmlFor="brotherPhoneNo">Brother Phone No</label>
//               <input
//                 type="text"
//                 id="brotherPhoneNo"
//                 style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}
//                 className="form-control"
//                 name="brotherPhoneNo"
//                 value={studentData.brotherPhoneNo}
//                 onChange={handleChange}
//                 onInput={(e) => e.target.value = e.target.value.replace(/\D/g, '').slice(0, 10)}
//               />
//               {errors.brotherPhoneNo && <p style={{ color: 'red' }}>{errors.brotherPhoneNo}</p>}
//             </div>
//           </div> */}

//           <div className="form-group" style={{ display: 'grid', gap: '6px', gridTemplateColumns: '1fr 1fr' }}>
//             <div>
//               <label htmlFor="profileFile">Upload Photo*</label>
//               <input
//                 type="file"
//                 required
//                 accept="image/png, image/jpeg, image/jpg"
//                 id="profileFile"
//                 onChange={handleFileChange(setProfileFile, ['image/png', 'image/jpeg', 'image/jpg'],
//                   "Profile Photo",
//                   "PNG, JPG, JPEG")}
//                 className="form-control"
//               />
//             </div>

//             <div>
//               <label htmlFor="nricFile">NRIC Document</label>
//               <input
//                 type="file"
//                 id="nricFile"
//                 accept="application/pdf"
//                 onChange={handleFileChange(setNricFile, ["application/pdf"], "NRIC Document",
//                   "PDF")}
//                 className="form-control"
//               />
//             </div>
//           </div>

//           <div className="form-group" style={{ display: 'grid', gap: '6px', gridTemplateColumns: '1fr 1fr' }}>
//             <div>
//               <label htmlFor="educationFile">Education Document</label>
//               <input
//                 type="file"
//                 id="educationFile"
//                 accept="application/pdf"
//                 onChange={handleFileChange(setEducationFile, ["application/pdf"], "Education Document",
//                   "PDF")}
//                 className="form-control"
//               />
//             </div>

//             <div>
//               <label htmlFor="passportFile">Passport Document</label>
//               <input
//                 type="file"
//                 id="passportFile"
//                 accept="application/pdf"
//                 onChange={handleFileChange(setPassportFile, ["application/pdf"], "Passport Document",
//                   "PDF")}
//                 className="form-control"
//               />
//             </div>
//           </div>

//           {/* Responsive Gap Adjustment */}



//           <br />

//           {/* Employment Status Fields */}
//           {
//             showEmploymentFields && (
//               studentData.workExpirences.map((experience, index) => (
//                 <div key={index} style={{ marginBottom: '15px', padding: '10px', border: '1px solid #ced4da', borderRadius: '6px' }} >
//                   <div className="form-group" >
//                     <label htmlFor={`companyname-${index}`}> Company Name * </label>
//                     < input
//                       type="text"
//                       id={`companyname-${index}`}
//                       style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}
//                       className="form-control"
//                       name="name"
//                       value={experience.name}
//                       onChange={(e) => handleWorkExperienceChange(index, e)}
//                       required
//                     />
//                   </div>

//                   < div className="form-group" >
//                     <label htmlFor={`position-${index}`}> Nature of Duties * </label>
//                     < input
//                       type="text"
//                       id={`position-${index}`}
//                       style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}
//                       className="form-control"
//                       name="position"
//                       value={experience.position}
//                       onChange={(e) => handleWorkExperienceChange(index, e)}
//                       required
//                     />
//                   </div>

//                   <div className="form-group" style={{ display: 'flex', gap: '16px' }}>
//                     {/* From Year */}
//                     <div style={{ flex: 1 }}>
//                       <label htmlFor={`fromYear-${index}`}>From Year *</label>
//                       <input
//                         type="number"
//                         id={`fromYear-${index}`}
//                         className="form-control"
//                         name="fromYear"
//                         value={experience.fromYear}
//                         onChange={(e) => handleWorkExperienceChange(index, e)}
//                         style={{
//                           width: '100%',
//                           height: '42px',
//                           borderRadius: '6px',
//                           border: '1px solid #ced4da'
//                         }}
//                         required
//                       />
//                     </div>

//                     {/* To Year */}
//                     <div style={{ flex: 1 }}>
//                       <label htmlFor={`toYear-${index}`}>To Year *</label>
//                       <input
//                         type="number"
//                         id={`toYear-${index}`}
//                         className="form-control"
//                         name="toYear"
//                         value={experience.toYear}
//                         onChange={(e) => handleWorkExperienceChange(index, e)}
//                         style={{
//                           width: '100%',
//                           height: '42px',
//                           borderRadius: '6px',
//                           border: '1px solid #ced4da'
//                         }}
//                         required
//                       />
//                     </div>

//                     {/* Country */}
//                     <div style={{ flex: 1 }}>
//                       <label htmlFor={`country-${index}`}>Country *</label>
//                       <input
//                         type="text"
//                         id={`country-${index}`}
//                         className="form-control"
//                         name="country"
//                         value={experience.country}
//                         onChange={(e) => handleWorkExperienceChange(index, e)}
//                         style={{
//                           width: '100%',
//                           height: '42px',
//                           borderRadius: '6px',
//                           border: '1px solid #ced4da'
//                         }}
//                         required
//                       />
//                     </div>
//                   </div>


//                   {/* Button to remove the work experience entry */}
//                   <button
//                     type="button"
//                     onClick={() => handleRemoveWorkExperience(index)}
//                     style={{
//                       margin: '10px 0',
//                       padding: '5px 15px',
//                       fontSize: '16px',
//                       backgroundColor: 'red',
//                       color: 'white',
//                       borderRadius: '8px',
//                       border: 'none',
//                       cursor: 'pointer',
//                       transition: 'background-color 0.3s ease',
//                       boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
//                     }}
//                   >
//                     Remove
//                   </button>
//                 </div>
//               ))
//             )}


//           <Button
//             type="submit"
//             variant="contained"
//             disabled={isUploading} // Disable button when uploading
//             style={{
//               float: 'right',
//               padding: '8px 50px',
//               fontSize: '16px',
//               backgroundColor: isUploading ? 'green' : 'green',
//               cursor: isUploading ? 'not-allowed' : 'pointer',
//             }}
//           >
//             {isUploading ? 'Submitting...' : 'Submit'}
//           </Button>


//         </div >
//       </form >
//       < ToastContainer />
//     </div >
//   );
// };


// const NewStudenth = ({ onFormSubmit }) => {
//   return (
//     <div>

//       {/* <NavigationButtons /> */}
//       < NewStudent onFormSubmit={onFormSubmit} />
//     </div>
//   );
// };

// export default NewStudenth;


import React, { useState, useEffect } from 'react';
import axios from '../Axiosinstance';
import { CLOUDINARY_UPLOAD_PRESET, baseURL, timestamp } from '../common';
import { toast, ToastContainer } from 'react-toastify';
import { Button, Grid, Stack } from '@mui/material';
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';

const NewStudent = ({ onFormSubmit }) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploadedFileUrl, setUploadedFileUrl] = useState('');
  const [showEmploymentFields, setShowEmploymentFields] = useState(false);
  const [profileFile, setProfileFile] = useState(null);
  const [nricFile, setNricFile] = useState(null);
  const [educationFile, setEducationFile] = useState(null);
  const [passportFile, setPassportFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [batches, setBatches] = useState([]);
  const [selectedBatch, setSelectedBatch] = useState(null);
  const [intakeOptions, setIntakeOptions] = useState([]);
  const [intakeIdsss, setIntakeIdsss] = useState('');
  const [warnings, setWarnings] = useState({});
  const [openDialog, setOpenDialog] = useState(false);
  const [alumniRegistrationId, setAlumniRegistrationId] = useState(null);
  const [allowAlumniRegistration, setAllowAlumniRegistration] = useState(null);

  const genderOptions = ["Male", "Female", "Other"];
  const statusOptions = ['Single', 'Married', 'Widowed', 'Divorced'];

  const [studentData, setStudentData] = useState({
    name: '',
    nric: '',
    email: '',
    phone: '',
    gender: '',
    dob: '',
    officephone: '',
    address: '',
    course: '',
    enrollmentDate: '',
    citizenship: '',
    signDate: '',
    religion: '',
    currentAddress: '',
    institutionDetails: [],
    emergencyContacts: [],
    workExpirences: [],
    projectSchedule: {
      projectCode: '',
      startDate: '',
      endDate: '',
    },
    nricdoc: '',
    educationdoc: '',
    passportdoc: '',
    scheduleDate: [],
    postalcode: '',
    completeDate: '',
    commencementDate: '',
    preIntake: '',
    maritalStatus: '',
    passport: '',
    passportExpiryDate: '',
    profileUrl: '',
    batchId: null,
    startModulus: null,
    type: '',
    durationType: '',
    proofType: '',
    relationship: '',
    fatherName: '',
    fatherPhoneNo: '',
    customId: '',
  });

  const [errors, setErrors] = useState({
    name: '',
    religion: '',
    citizenship: '',
    nric: '',
    officephone: '',
    fatherPhoneNo: '',
  });

  const styles = {
    formContainer: {
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '20px',
      backgroundColor: '#f9f9f9',
      borderRadius: '8px',
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    },
    columnsContainer: {
      display: 'flex',
      gap: '24px',
      marginBottom: '24px',
    },
    column: { flex: 1, minWidth: 0 },
    section: {
      marginBottom: '24px',
      padding: '20px',
      backgroundColor: '#fff',
      borderRadius: '8px',
      boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
    },
    sectionTitle: {
      marginTop: 0,
      marginBottom: '20px',
      color: '#333',
      fontSize: '18px',
      fontWeight: '600',
      borderBottom: '1px solid #eee',
      paddingBottom: '8px',
    },
    formGroup: { marginBottom: '16px' },
    label: {
      display: 'block',
      marginBottom: '6px',
      fontSize: '14px',
      fontWeight: '500',
      color: '#555',
    },
    input: {
      width: '100%',
      padding: '10px 12px',
      fontSize: '14px',
      border: '1px solid #ddd',
      borderRadius: '4px',
      boxSizing: 'border-box',
      height: '40px',
    },
    select: {
      width: '100%',
      padding: '10px 12px',
      fontSize: '14px',
      border: '1px solid #ddd',
      borderRadius: '4px',
      boxSizing: 'border-box',
      height: '40px',
      backgroundColor: '#fff',
    },
    errorText: { color: '#d32f2f', fontSize: '12px', marginTop: '4px' },
    warningText: { color: '#ff9800', fontSize: '12px', marginTop: '4px' },
    submitButton: {
      padding: '12px 24px',
      backgroundColor: '#4285f4',
      color: '#fff',
      border: 'none',
      borderRadius: '4px',
      fontSize: '16px',
      fontWeight: '500',
      cursor: 'pointer',
    },
    moduleCard: {
      padding: '16px',
      border: '1px solid #e0e0e0',
      borderRadius: '8px',
      backgroundColor: '#fafafa',
    },
    removeButton: {
      padding: '8px 16px',
      backgroundColor: '#f44336',
      color: '#fff',
      border: 'none',
      borderRadius: '4px',
      cursor: 'pointer',
    },
  };

  // ─── Fetch Batches ──────────────────────────────────────────────────────────
  useEffect(() => {
    const fetchBatches = async () => {
      try {
        const response = await axios.get('batch-summary');
        setBatches(response.data);
      } catch (error) {
        console.error('Error fetching batches:', error);
      }
    };
    fetchBatches();
  }, []);

  // ─── Fetch Intake Options for Selected Batch ────────────────────────────────
  const fetchIntake = async (batchId) => {
    try {
      const response = await axios.get(`/intake-details/batch/${batchId}`);
      setIntakeOptions(response.data);
    } catch (error) {
      console.error('Error fetching intake details:', error);
    }
  };

  // ─── NRIC / Email Check (Allians-style: status-aware) ───────────────────────
  const handleNricEmailChange = async (e) => {
    const { name, value } = e.target;
    setStudentData((prev) => ({ ...prev, [name]: value }));

    if (value.trim() === '') {
      setErrors((prev) => ({ ...prev, [name]: '' }));
      setWarnings((prev) => ({ ...prev, [name]: '' }));
      return;
    }

    try {
      if (name === 'nric') {
        const response = await axios.get(`/registrationadvances/findExists?nric=${value}`);
        const data = response.data;

        if (data === true) {
          // NRIC not found anywhere – allow
          setErrors((prev) => ({ ...prev, [name]: '' }));
          setWarnings((prev) => ({ ...prev, [name]: '' }));
        } else if (data?.status === 'Alumni') {
          setErrors((prev) => ({ ...prev, [name]: '' }));
          setWarnings((prev) => ({ ...prev, [name]: '' }));
          setAlumniRegistrationId(data.registrationId);
          setOpenDialog(true);
        } else if (data?.status === 'Active') {
          setErrors((prev) => ({
            ...prev,
            [name]: `NRIC already exists with status: Active. Registration not allowed.`,
          }));
          setWarnings((prev) => ({ ...prev, [name]: '' }));
        } else if (data?.status === 'New') {
          setErrors((prev) => ({ ...prev, [name]: '' }));
          setWarnings((prev) => ({
            ...prev,
            [name]: `⚠️ Warning: This NRIC already exists with status "New".`,
          }));
        } else if (data?.status === 'two-new') {
          setErrors((prev) => ({ ...prev, [name]: '' }));
          setWarnings((prev) => ({
            ...prev,
            [name]: `⚠️ Warning: This NRIC has two existing New registrations.`,
          }));
        } else {
          setErrors((prev) => ({ ...prev, [name]: '' }));
          setWarnings((prev) => ({ ...prev, [name]: '' }));
        }
      } else if (name === 'email') {
        const response = await axios.get(`/registrationadvances/exists?email=${value}`);
        const exists = response.data;
        if (exists === true) {
          setErrors((prev) => ({
            ...prev,
            [name]: `EMAIL already exists. Registration not allowed.`,
          }));
        } else {
          setErrors((prev) => ({ ...prev, [name]: '' }));
        }
        setWarnings((prev) => ({ ...prev, [name]: '' }));
      }
    } catch (error) {
      console.error(`Error checking ${name}:`, error);
      setErrors((prev) => ({ ...prev, [name]: `Error checking ${name}. Try again!` }));
    }
  };

  // ─── General Field Change ────────────────────────────────────────────────────
  const handleChange = (e) => {
    const { name, value } = e.target;
    const lettersOnlyRegex = /^[a-zA-Z\s]*$/;
    const onlyNumberRegex = /^[0-9]*$/;
    let errorMessage = '';

    if (['name', 'religion', 'citizenship'].includes(name) && !lettersOnlyRegex.test(value)) {
      errorMessage = 'Only letters are allowed.';
    }
    if (['fatherPhoneNo', 'officephone'].includes(name) && !onlyNumberRegex.test(value)) {
      errorMessage = 'Only numbers are allowed.';
    }
    if (['passportExpiryDate', 'dob'].includes(name)) {
      const year = value.split('-')[0];
      if (year.length > 4) errorMessage = 'Year cannot be more than 4 digits.';
    }

    setErrors((prev) => ({ ...prev, [name]: errorMessage }));
    if (errorMessage) return;

    if (name === 'course') {
      if (!value) {
        setSelectedBatch(null);
        setIntakeOptions([]);
        setIntakeIdsss('');
        setStudentData((prev) => ({
          ...prev,
          course: '',
          batchId: null,
          startModulus: null,
          enrollmentDate: '',
          scheduleDate: [],
        }));
        return;
      }

      const batch = batches.find((b) => b.course?.trim() === value.trim());
      if (!batch) return;

      setSelectedBatch(batch);
      fetchIntake(batch.id);

      const moduleCount = batch.moduleDetails?.length || 0;
      const newScheduleDate = Array.from({ length: moduleCount }, () => ({
        startModulus: '',
        startDate: '',
        endDate: '',
      }));

      setStudentData((prev) => ({
        ...prev,
        course: value,
        batchId: batch.id || null,
        enrollmentDate: '',
        scheduleDate: newScheduleDate,
      }));
    } else {
      setStudentData((prev) => ({ ...prev, [name]: value }));
    }
  };

  // ─── Intake Selection (import schedule from existing intake) ─────────────────
  const handleIntakeChange = (e) => {
    const selectedIntakeId = e.target.value;
    setIntakeIdsss(selectedIntakeId);

    if (!selectedIntakeId) {
      setStudentData((prev) => ({ ...prev, scheduleDate: [], preIntake: '' }));
      return;
    }

    const selectedIntake = intakeOptions.find(
      (intake) => String(intake.intakeId) === selectedIntakeId
    );

    if (selectedIntake) {
      const scheduleData = selectedIntake.scheduleDateDetails.map((schedule) => ({
        startModulus: schedule.startModulus,
        startDate: schedule.startDate,
        endDate: schedule.endDate,
      }));

      setStudentData((prev) => ({
        ...prev,
        scheduleDate: scheduleData,
        preIntake: selectedIntakeId,
      }));
    }
  };

  // ─── Manual Schedule Calculation (weekPerModule-based like Allians) ──────────
  const getCycledModuli = (start, count) => {
    const moduleCount = selectedBatch?.moduleDetails?.length || count;
    return Array.from({ length: count }, (_, i) => ((start + i - 1) % moduleCount) + 1);
  };

  const getNextWeekDates = (startDateStr) => {
    const start = new Date(startDateStr);
    const weekCount = selectedBatch?.weekPerModule || 4;
    const endDate = new Date(start);
    endDate.setDate(start.getDate() + (weekCount - 1) * 7);
    const nextStartDate = new Date(endDate);
    nextStartDate.setDate(endDate.getDate() + 7);
    return {
      endDate: endDate.toISOString().split('T')[0],
      nextStartDate: nextStartDate.toISOString().split('T')[0],
    };
  };

  const handleManualScheduleStart = (firstModulus, firstDate) => {
    if (!firstDate) {
      toast.warning('Please select Start Date first.');
      return;
    }
    const totalModules = selectedBatch?.moduleDetails?.length || 0;
    const moduli = getCycledModuli(parseInt(firstModulus), totalModules);
    let startDate = firstDate;
    const modules = [];

    for (let i = 0; i < totalModules; i++) {
      const { endDate, nextStartDate } = getNextWeekDates(startDate);
      modules.push({ startModulus: moduli[i], startDate, endDate });
      startDate = nextStartDate;
    }

    setStudentData((prev) => ({ ...prev, scheduleDate: modules }));
  };

  const handleModuleChange = (index, field, value) => {
    const updated = [...studentData.scheduleDate];
    updated[index][field] = field === 'startModulus' ? parseInt(value) : value;
    setStudentData({ ...studentData, scheduleDate: updated });
  };

  // ─── Project Schedule ────────────────────────────────────────────────────────
  const handleProjectChange = (field, value) => {
    setStudentData((prev) => ({
      ...prev,
      projectSchedule: { ...prev.projectSchedule, [field]: value },
    }));
  };

  // ─── File Upload ─────────────────────────────────────────────────────────────
  const handleFileChange = (setFile, allowedTypes, fieldName, allowedFormatsText) => (event) => {
    const file = event.target.files[0];
    if (!file) return;
    if (file.size > 8 * 1024 * 1024) {
      event.target.value = '';
      toast.error('Max file size 8MB');
      return;
    }
    if (!allowedTypes.includes(file.type)) {
      event.target.value = '';
      toast.error(`${fieldName}: Only ${allowedFormatsText}`);
      return;
    }
    setFile(file);
  };

  // ─── Education ───────────────────────────────────────────────────────────────
  const handleInstitutionChange = (index, e) => {
    const { name, value } = e.target;
    const updated = studentData.institutionDetails.map((inst, i) => {
      if (i !== index) return inst;
      const updatedInst = { ...inst, [name]: value };
      const fromYear = name === 'fromYear' ? value : updatedInst.fromYear;
      const toYear = name === 'toYear' ? value : updatedInst.toYear;
      if (
        fromYear?.length === 4 && toYear?.length === 4 &&
        !isNaN(Number(fromYear)) && !isNaN(Number(toYear)) &&
        Number(toYear) < Number(fromYear)
      ) {
        toast.error('To Year must be >= From Year');
      }
      return updatedInst;
    });
    setStudentData({ ...studentData, institutionDetails: updated });
  };

  const handleAddEducation = () => {
    setStudentData({
      ...studentData,
      institutionDetails: [
        ...studentData.institutionDetails,
        { institution: '', fromYear: '', toYear: '', qualificationsAchieved: '', highest: false, country: '', educationCertificateNo: '' },
      ],
    });
  };

  const handleRemoveEducation = (index) => {
    setStudentData({
      ...studentData,
      institutionDetails: studentData.institutionDetails.filter((_, i) => i !== index),
    });
  };

  // ─── Emergency Contacts ───────────────────────────────────────────────────────
  const handleEmergencyChange = (index, field, value) => {
    const updated = [...studentData.emergencyContacts];
    updated[index][field] = value;
    setStudentData({ ...studentData, emergencyContacts: updated });
  };

  const handleAddEmergency = () => {
    setStudentData({
      ...studentData,
      emergencyContacts: [
        ...studentData.emergencyContacts,
        { name: '', number: '', relationship: '', othersRelationship: '' },
      ],
    });
  };

  const handleRemoveEmergency = (index) => {
    const updated = [...studentData.emergencyContacts];
    updated.splice(index, 1);
    setStudentData({ ...studentData, emergencyContacts: updated });
  };

  // ─── Work Experience ─────────────────────────────────────────────────────────
  const handleWorkExperienceChange = (index, e) => {
    const { name, value } = e.target;
    const updated = [...studentData.workExpirences];
    updated[index] = { ...updated[index], [name]: value };

    const fromYear = parseInt(updated[index].fromYear);
    const toYear = parseInt(updated[index].toYear);
    if (
      updated[index].fromYear?.length === 4 &&
      updated[index].toYear?.length === 4 &&
      !isNaN(fromYear) && !isNaN(toYear) && toYear < fromYear
    ) {
      toast.error('To Year must be >= From Year');
    }
    setStudentData({ ...studentData, workExpirences: updated });
  };

  const handleAddWorkExperience = () => {
    setStudentData((prev) => ({
      ...prev,
      workExpirences: [
        ...prev.workExpirences,
        { name: '', position: '', fromYear: '', toYear: '', country: '' },
      ],
    }));
    setShowEmploymentFields(true);
  };

  const handleRemoveWorkExperience = (index) => {
    const updated = studentData.workExpirences.filter((_, i) => i !== index);
    setStudentData({ ...studentData, workExpirences: updated });
    if (updated.length === 0) setShowEmploymentFields(false);
  };

  // ─── Alumni Re-registration ──────────────────────────────────────────────────
  const deleteAlumniRegistration = async () => {
    if (!alumniRegistrationId) return;
    try {
      await axios.delete(`/registrationadvances/${alumniRegistrationId}`);
      setAllowAlumniRegistration(true);
    } catch (err) {
      console.error('Failed to delete alumni registration:', err);
    } finally {
      setOpenDialog(false);
      setAlumniRegistrationId(null);
    }
  };

  // ─── Submit ──────────────────────────────────────────────────────────────────
  const handleSubmit = async (e) => {
    e.preventDefault();

    // if (Object.values(errors).some((err) => err.trim() !== '')) {
    //   toast.error('Please resolve all validation errors before submitting.');
    //   return;
    // }

    const validationErrors = Object.entries(errors)
  .filter(([key, value]) => value && value.trim() !== '');

if (validationErrors.length > 0) {

  console.log('Validation Errors:', validationErrors);

  toast.error(
    validationErrors
      .map(([field, message]) => `${field}: ${message}`)
      .join(' | ')
  );

  return;
}

    const highestCount = studentData.institutionDetails.filter((inst) => inst.highest).length;
    if (studentData.institutionDetails.length > 0 && highestCount !== 1) {
      toast.error('Please select exactly one education entry as "Highest".');
      return;
    }

    if (allowAlumniRegistration === false) {
      toast.error('Alumni registration is not allowed for this NRIC.');
      return;
    }

    try {
      setIsUploading(true);
      const uploadFile = async (file) => {
        if (!file) return '';
        const formData = new FormData();
        formData.append('file', file);
        formData.append('upload_preset', CLOUDINARY_UPLOAD_PRESET);
        formData.append('public_id', `LMS/${file.name} - ${timestamp}`);
        const response = await fetch(baseURL, { method: 'POST', body: formData });
        const data = await response.json();
        if (data.secure_url) return data.secure_url;
        throw new Error('Failed to upload file.');
      };

      const profileUrl = await uploadFile(profileFile);
      const nricdoc = await uploadFile(nricFile);
      const passportdoc = await uploadFile(passportFile);
      const educationdoc = await uploadFile(educationFile);

      const currentDate = new Date().toISOString().split('T')[0];

      const updatedStudentData = {
        ...studentData,
        password: studentData.nric,
        profileUrl,
        nricdoc,
        passportdoc,
        educationdoc,
        offerDate: currentDate,
        enrollmentDate: currentDate,
        startModulus: studentData?.scheduleDate?.[0]?.startModulus || studentData.startModulus,
      };

      await axios.post('registrationadvances', updatedStudentData);
      toast.success('Student added successfully');
      if (onFormSubmit) onFormSubmit();
    } catch (error) {
      console.error('Error submitting student data:', error);
      toast.error('Failed to submit student data. Please try again.');
    } finally {
      setIsUploading(false);
    }
  };

  // ─── Render ──────────────────────────────────────────────────────────────────
  return (
    <div style={{ maxWidth: '1200px', background: '#fff', padding: '20px', boxShadow: '0px 0px 2px 0px #000', borderRadius: '10px', marginTop: '1%', margin: '1% auto' }}>
      <h4>New Student (AEG International College)</h4>
      <hr style={{ marginTop: '1%' }} />

      <form onSubmit={handleSubmit} style={styles.formContainer}>
        <div style={styles.columnsContainer}>

          {/* ── LEFT COLUMN ── */}
          <div style={styles.column}>

            {/* Personal Information */}
            <div style={styles.section}>
              <h3 style={styles.sectionTitle}>Personal Information</h3>

              <div style={styles.formGroup}>
                <label style={styles.label}>Name *</label>
                <input type="text" style={styles.input} name="name" value={studentData.name} onChange={handleChange} required />
               {errors.name && <p style={styles.errorText}>{errors.name}</p>}
              </div>

              <div style={styles.formGroup}>
                <label style={styles.label}>Proof Type *</label>
                <select style={styles.select} name="proofType" value={studentData.proofType} onChange={handleChange} required>
                  <option value="">Select Proof Type</option>
                  <option value="NRIC">NRIC</option>
                  <option value="FIN">FIN</option>
                </select>
              </div>

              <div style={styles.formGroup}>
                <label style={styles.label}>NRIC / FIN No *</label>
                <input type="text" style={styles.input} name="nric" value={studentData.nric || ''} onChange={handleNricEmailChange} required maxLength={10} />
                {errors.nric && <p style={styles.errorText}>{errors.nric}</p>}
                {warnings.nric && !errors.nric && <p style={styles.warningText}>{warnings.nric}</p>}
              </div>

              <div style={styles.formGroup}>
                <label style={styles.label}>Email *</label>
                <input type="email" style={styles.input} name="email" value={studentData.email} onChange={handleNricEmailChange} required maxLength={100} />
                {errors.email && <p style={styles.errorText}>{errors.email}</p>}
              </div>

              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <div style={styles.formGroup}>
                    <label style={styles.label}>Gender *</label>
                    <select style={styles.select} name="gender" value={studentData.gender} onChange={handleChange} required>
                      <option value="">Select Gender</option>
                      {genderOptions.map((o) => <option key={o} value={o}>{o}</option>)}
                    </select>
                  </div>
                </Grid>
                <Grid item xs={12} md={6}>
                  <div style={styles.formGroup}>
                    <label style={styles.label}>Marital Status *</label>
                    <select style={styles.select} name="maritalStatus" value={studentData.maritalStatus} onChange={handleChange} required>
                      <option value="">Select Status</option>
                      {statusOptions.map((o) => <option key={o} value={o}>{o}</option>)}
                    </select>
                  </div>
                </Grid>
              </Grid>

              <div style={styles.formGroup}>
                <label style={styles.label}>Date of Birth *</label>
                <input type="date" style={styles.input} name="dob" value={studentData.dob} onChange={handleChange} required />
              </div>
            </div>

            {/* Contact Information */}
            <div style={styles.section}>
              <h3 style={styles.sectionTitle}>Contact Information</h3>

              <div style={{ display: 'flex', gap: '16px', marginBottom: '16px' }}>
                <div style={{ flex: 1 }}>
                  <label style={styles.label}>Religion *</label>
                  <input type="text" style={styles.input} name="religion" value={studentData.religion} onChange={handleChange} required />
                  {errors.religion && <p style={styles.errorText}>{errors.religion}</p>}
                </div>
                <div style={{ flex: 1 }}>
                  <label style={styles.label}>Citizenship *</label>
                  <input type="text" style={styles.input} name="citizenship" value={studentData.citizenship} onChange={handleChange} required />
                  {errors.citizenship && <p style={styles.errorText}>{errors.citizenship}</p>}
                </div>
              </div>

              <div style={{ display: 'flex', gap: '16px', marginBottom: '16px' }}>
                <div style={{ flex: 1 }}>
                  <label style={styles.label}>Hand Phone *</label>
                  <input type="tel" style={styles.input} name="phone" value={studentData.phone} onChange={handleChange} required
                    onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 10); }} />
                </div>
                <div style={{ flex: 1 }}>
                  <label style={styles.label}>Office Phone</label>
                  <input type="tel" style={styles.input} name="officephone" value={studentData.officephone} onChange={handleChange}
                    onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 10); }} />
                  {errors.officephone && <p style={styles.errorText}>{errors.officephone}</p>}
                </div>
              </div>

              <div style={styles.formGroup}>
                <label style={styles.label}>Postal Code</label>
                <input type="text" style={styles.input} name="postalcode" value={studentData.postalcode} onChange={(e) => {
                  if (/^\d{0,6}$/.test(e.target.value)) handleChange(e);
                }} maxLength={6} />
              </div>

              <div style={styles.formGroup}>
                <label style={styles.label}>Home Address *</label>
                <input type="text" style={styles.input} name="address" value={studentData.address} onChange={handleChange} required />
              </div>

              <div style={styles.formGroup}>
                <label style={styles.label}>Singapore Address</label>
                <input type="text" style={styles.input} name="currentAddress" value={studentData.currentAddress} onChange={handleChange} />
              </div>

              <div style={styles.formGroup}>
                <label style={styles.label}>Relationship *</label>
                <input type="text" style={styles.input} name="relationship" value={studentData.relationship} onChange={handleChange} required />
              </div>

              <div style={{ display: 'grid', gap: '6px', gridTemplateColumns: '1fr 1fr' }}>
                <div>
                  <label style={styles.label}>Emergency Contact Name</label>
                  <input type="text" style={styles.input} name="fatherName" value={studentData.fatherName} onChange={handleChange} />
                  {errors.fatherName && <p style={styles.errorText}>{errors.fatherName}</p>}
                </div>
                <div>
                  <label style={styles.label}>Emergency Contact Number</label>
                  <input type="text" style={styles.input} name="fatherPhoneNo" value={studentData.fatherPhoneNo} onChange={handleChange}
                    onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 10); }} />
                  {errors.fatherPhoneNo && <p style={styles.errorText}>{errors.fatherPhoneNo}</p>}
                </div>
              </div>
            </div>

            {/* Education */}
            <div style={styles.section}>
              <h3 style={styles.sectionTitle}>Education</h3>

              <Stack direction="row" spacing={2} sx={{ mb: 2 }}>
                <Button type="button" variant="contained" fullWidth onClick={handleAddEducation}>
                  + Add Education
                </Button>
                <Button type="button" variant="contained" fullWidth onClick={handleAddWorkExperience}>
                  + Add Employment
                </Button>
              </Stack>

              {studentData.institutionDetails.map((institution, index) => (
                <div key={index} style={{ marginBottom: '16px', padding: '16px', border: '1px solid #ddd', borderRadius: '8px' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
                    <label style={styles.label}>Institution *</label>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <input type="checkbox" id={`highest-${index}`} checked={institution.highest || false}
                        onChange={(e) => {
                          const updated = studentData.institutionDetails.map((inst, i) => ({
                            ...inst,
                            highest: i === index ? e.target.checked : false,
                          }));
                          setStudentData({ ...studentData, institutionDetails: updated });
                        }} style={{ marginRight: '4px' }} />
                      <label htmlFor={`highest-${index}`} style={{ fontSize: '12px' }}>Highest</label>
                    </div>
                  </div>
                  <input type="text" name="institution" style={{ ...styles.input, marginBottom: '8px' }} value={institution.institution}
                    onChange={(e) => handleInstitutionChange(index, e)} required />

                  <label style={styles.label}>Degree *</label>
                  <input type="text" name="qualificationsAchieved" style={{ ...styles.input, marginBottom: '8px' }} value={institution.qualificationsAchieved}
                    onChange={(e) => handleInstitutionChange(index, e)} required />

                  <label style={styles.label}>Country *</label>
                  <input type="text" name="country" style={{ ...styles.input, marginBottom: '8px' }} value={institution.country}
                    onChange={(e) => handleInstitutionChange(index, e)} required />

                  <label style={styles.label}>Certificate Number</label>
                  <input type="text" name="educationCertificateNo" style={{ ...styles.input, marginBottom: '8px' }} value={institution.educationCertificateNo}
                    onChange={(e) => handleInstitutionChange(index, e)} />

                  <div style={{ display: 'flex', gap: '16px' }}>
                    <div style={{ flex: 1 }}>
                      <label style={styles.label}>From Year *</label>
                      <input type="number" name="fromYear" style={styles.input} value={institution.fromYear}
                        onChange={(e) => handleInstitutionChange(index, e)} required />
                    </div>
                    <div style={{ flex: 1 }}>
                      <label style={styles.label}>To Year *</label>
                      <input type="number" name="toYear" style={styles.input} value={institution.toYear}
                        onChange={(e) => handleInstitutionChange(index, e)} required />
                    </div>
                  </div>

                  <button type="button" onClick={() => handleRemoveEducation(index)} style={{ ...styles.removeButton, marginTop: '10px' }}>
                    Remove
                  </button>
                </div>
              ))}
            </div>
          </div>

          {/* ── RIGHT COLUMN ── */}
          <div style={styles.column}>

            {/* Upload Documents */}
            <div style={styles.section}>
              <h3 style={styles.sectionTitle}>Upload Documents</h3>
              <div style={{ display: 'flex', gap: '16px', marginBottom: '16px', flexWrap: 'wrap' }}>
                <div style={{ flex: '1 1 200px' }}>
                  <label style={styles.label}>Upload Photo *</label>
                  <input type="file" accept="image/png, image/jpeg, image/jpg" required
                    onChange={handleFileChange(setProfileFile, ['image/png', 'image/jpeg', 'image/jpg'], 'Profile Photo', 'PNG, JPG, JPEG')} />
                </div>
                <div style={{ flex: '1 1 200px' }}>
                  <label style={styles.label}>NRIC Document</label>
                  <input type="file" accept="application/pdf"
                    onChange={handleFileChange(setNricFile, ['application/pdf'], 'NRIC Document', 'PDF')} />
                </div>
              </div>
              <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
                <div style={{ flex: '1 1 200px' }}>
                  <label style={styles.label}>Education Document</label>
                  <input type="file" accept="application/pdf"
                    onChange={handleFileChange(setEducationFile, ['application/pdf'], 'Education Document', 'PDF')} />
                </div>
                <div style={{ flex: '1 1 200px' }}>
                  <label style={styles.label}>Passport Document</label>
                  <input type="file" accept="application/pdf"
                    onChange={handleFileChange(setPassportFile, ['application/pdf'], 'Passport Document', 'PDF')} />
                </div>
              </div>
            </div>

            {/* Document Information */}
            <div style={styles.section}>
              <h3 style={styles.sectionTitle}>Document Information</h3>
              <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
                <div style={{ flex: '1 1 200px' }}>
                  <label style={styles.label}>Passport Number *</label>
                  <input type="text" style={styles.input} name="passport" value={studentData.passport} onChange={handleChange} maxLength={20} required />
                </div>
                <div style={{ flex: '1 1 200px' }}>
                  <label style={styles.label}>Passport Expiry Date *</label>
                  <input type="date" style={styles.input} name="passportExpiryDate" value={studentData.passportExpiryDate} onChange={handleChange} required />
                </div>
              </div>
            </div>

            {/* Emergency Contacts */}
            <div style={styles.section}>
              <h3 style={styles.sectionTitle}>Emergency Contacts</h3>

              {studentData.emergencyContacts.map((contact, index) => (
                <div key={index} style={{ marginBottom: '20px', border: '1px solid #ddd', padding: '16px', borderRadius: '8px' }}>
                  <div style={{ marginBottom: '12px' }}>
                    <label style={styles.label}>Relationship</label>
                    <select style={styles.select} value={contact.relationship}
                      onChange={(e) => handleEmergencyChange(index, 'relationship', e.target.value)} required>
                      <option value="">-- Select Relationship --</option>
                      <option value="Father">Father</option>
                      <option value="Mother">Mother</option>
                      <option value="Brother">Brother</option>
                      <option value="Sister">Sister</option>
                      <option value="Others">Others</option>
                    </select>
                  </div>

                  {contact.relationship === 'Others' && (
                    <div style={{ marginBottom: '12px' }}>
                      <label style={styles.label}>Relationship with Applicant</label>
                      <input type="text" style={styles.input} placeholder="Enter relationship"
                        value={contact.othersRelationship}
                        onChange={(e) => handleEmergencyChange(index, 'othersRelationship', e.target.value)} required />
                    </div>
                  )}

                  <div style={{ display: 'flex', gap: '16px', marginBottom: '12px', flexWrap: 'wrap' }}>
                    <div style={{ flex: '1 1 200px' }}>
                      <label style={styles.label}>Name</label>
                      <input type="text" style={styles.input} value={contact.name}
                        onChange={(e) => handleEmergencyChange(index, 'name', e.target.value)} required />
                    </div>
                    <div style={{ flex: '1 1 200px' }}>
                      <label style={styles.label}>Contact No</label>
                      <input type="tel" maxLength={10} style={styles.input} value={contact.number}
                        onChange={(e) => handleEmergencyChange(index, 'number', e.target.value)} required />
                    </div>
                  </div>

                  <div style={{ textAlign: 'right' }}>
                    <button type="button" onClick={() => handleRemoveEmergency(index)} style={styles.removeButton}>
                      Remove
                    </button>
                  </div>
                </div>
              ))}

              <Button type="button" onClick={handleAddEmergency} variant="contained" fullWidth>
                + ADD EMERGENCY
              </Button>
            </div>

            {/* Course Information */}
            <div style={styles.section}>
              <h3 style={styles.sectionTitle}>Course Information</h3>

              <div style={styles.formGroup}>
                <label style={styles.label}>Duration Type *</label>
                <select style={styles.select} name="durationType" value={studentData.durationType} onChange={handleChange} required>
                  <option value="">Select Course Type</option>
                  <option value="part_time">Part Time</option>
                  <option value="full_time">Full Time</option>
                </select>
              </div>

              <div style={styles.formGroup}>
                <label style={styles.label}>Course *</label>
                <select style={styles.select} name="course" value={studentData.course} onChange={handleChange} required>
                  <option value="">Select Course...</option>
                  {batches.map((batch) => (
                    <option key={batch.id} value={batch.course}>{batch.course}</option>
                  ))}
                </select>
              </div>

              <div style={styles.formGroup}>
                <label style={styles.label}>Select Intake</label>
                <select style={styles.select} value={intakeIdsss} onChange={handleIntakeChange}>
                  <option value="">-- Select Intake --</option>
                  {intakeOptions.map((intake) => (
                    <option key={intake.id} value={intake.intakeId}>{intake.intakeId}</option>
                  ))}
                </select>
              </div>
            </div>

            {/* Employment */}
            {showEmploymentFields && (
              <div style={styles.section}>
                <h3 style={styles.sectionTitle}>Employment History</h3>
                {studentData.workExpirences.map((experience, index) => (
                  <div key={index} style={{ padding: '16px', border: '1px solid #ddd', borderRadius: '8px', marginBottom: '16px' }}>
                    <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
                      <div style={{ flex: '1 1 200px' }}>
                        <label style={styles.label}>Company Name *</label>
                        <input type="text" name="name" style={styles.input} value={experience.name}
                          onChange={(e) => handleWorkExperienceChange(index, e)} required />
                      </div>
                      <div style={{ flex: '1 1 200px' }}>
                        <label style={styles.label}>Nature of Duties *</label>
                        <input type="text" name="position" style={styles.input} value={experience.position}
                          onChange={(e) => handleWorkExperienceChange(index, e)} required />
                      </div>
                      <div style={{ flex: '1 1 150px' }}>
                        <label style={styles.label}>Country *</label>
                        <input type="text" name="country" style={styles.input} value={experience.country}
                          onChange={(e) => handleWorkExperienceChange(index, e)} required />
                      </div>
                    </div>
                    <div style={{ display: 'flex', gap: '16px', marginTop: '8px' }}>
                      <div style={{ flex: 1 }}>
                        <label style={styles.label}>From Year *</label>
                        <input type="number" name="fromYear" style={styles.input} value={experience.fromYear}
                          onChange={(e) => handleWorkExperienceChange(index, e)} required />
                      </div>
                      <div style={{ flex: 1 }}>
                        <label style={styles.label}>To Year *</label>
                        <input type="number" name="toYear" style={styles.input} value={experience.toYear}
                          onChange={(e) => handleWorkExperienceChange(index, e)} required />
                      </div>
                    </div>
                    <button type="button" onClick={() => handleRemoveWorkExperience(index)} style={{ ...styles.removeButton, marginTop: '10px' }}>
                      Remove
                    </button>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        {/* ── MODULE SCHEDULE ── */}
        {studentData.scheduleDate.length > 0 && (
          <div style={styles.section}>
            <h3 style={styles.sectionTitle}>Module Schedule</h3>

            <div style={{ display: 'flex', gap: '16px', marginBottom: '16px', flexWrap: 'wrap' }}>
              <div style={{ flex: '1 1 200px' }}>
                <label style={styles.label}>Start Date</label>
                <input type="date" style={styles.input} value={studentData.scheduleDate[0]?.startDate || ''}
                  onChange={(e) => handleManualScheduleStart(studentData.scheduleDate[0]?.startModulus || '', e.target.value)} />
              </div>
              <div style={{ flex: '1 1 200px' }}>
                <label style={styles.label}>Start Module</label>
                <select style={styles.select} value={studentData.scheduleDate[0]?.startModulus || ''}
                  onChange={(e) => handleManualScheduleStart(e.target.value, studentData.scheduleDate[0]?.startDate || '')}>
                  <option value="">Select Module</option>
                  {selectedBatch?.moduleDetails?.map((module) => (
                    <option key={module.id} value={module.id}>{module.moduleName}</option>
                  ))}
                </select>
              </div>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: '16px' }}>
              {studentData.scheduleDate.map((module, index) => (
                <div key={index} style={styles.moduleCard}>
                  <h6 style={{ marginBottom: '12px', fontWeight: '600' }}>Module {index + 1}</h6>
                  <div style={styles.formGroup}>
                    <label style={styles.label}>Start Module</label>
                    <input style={styles.input}
                      value={selectedBatch?.moduleDetails?.find((m) => m.id === module.startModulus)?.moduleName || module.startModulus}
                      readOnly />
                  </div>
                  <div style={styles.formGroup}>
                    <label style={styles.label}>Start Date</label>
                    <input type="date" style={styles.input} value={module.startDate}
                      onChange={(e) => handleModuleChange(index, 'startDate', e.target.value)} required />
                  </div>
                  <div style={styles.formGroup}>
                    <label style={styles.label}>End Date</label>
                    <input type="date" style={styles.input} value={module.endDate}
                      onChange={(e) => handleModuleChange(index, 'endDate', e.target.value)} required />
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* ── PROJECT + DATES ── */}
        <div style={styles.columnsContainer}>
          {selectedBatch?.project === true && (
            <div style={styles.column}>
              <div style={styles.section}>
                <h3 style={styles.sectionTitle}>Project Details</h3>
                <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
                  <div style={{ flex: '1 1 200px' }}>
                    <label style={styles.label}>Project Code *</label>
                    <input type="text" style={styles.input} value={studentData.projectSchedule?.projectCode || ''}
                      onChange={(e) => handleProjectChange('projectCode', e.target.value)} required />
                  </div>
                  <div style={{ flex: '1 1 150px' }}>
                    <label style={styles.label}>Start Date *</label>
                    <input type="date" style={styles.input} value={studentData.projectSchedule?.startDate || ''}
                      onChange={(e) => handleProjectChange('startDate', e.target.value)} required />
                  </div>
                  <div style={{ flex: '1 1 150px' }}>
                    <label style={styles.label}>End Date *</label>
                    <input type="date" style={styles.input} value={studentData.projectSchedule?.endDate || ''}
                      onChange={(e) => handleProjectChange('endDate', e.target.value)} required />
                  </div>
                </div>
              </div>
            </div>
          )}

          <div style={styles.column}>
            <div style={styles.section}>
              <h3 style={styles.sectionTitle}>Commencement & Completion</h3>
              <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap', marginBottom: '16px' }}>
                <div style={{ flex: '1 1 100px' }}>
                  <label style={styles.label}>Commencement Date *</label>
                  <input type="date" style={styles.input} name="commencementDate" value={studentData.commencementDate} onChange={handleChange} required />
                </div>
                <div style={{ flex: '1 1 100px' }}>
                  <label style={styles.label}>Complete Date *</label>
                  <input type="date" style={styles.input} name="completeDate" value={studentData.completeDate} onChange={handleChange} required />
                </div>
              </div>
              <div>
                <label style={styles.label}>Sign Date *</label>
                <input type="date" style={styles.input} name="signDate" value={studentData.signDate} onChange={handleChange} required />
              </div>
            </div>
          </div>
        </div>

        {/* Submit */}
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '16px' }}>
          <button type="submit" style={styles.submitButton} disabled={isUploading}>
            {isUploading ? 'Submitting...' : 'Submit'}
          </button>
        </div>
      </form>

      <ToastContainer />

      {/* Alumni Re-registration Dialog */}
      <Dialog open={openDialog} onClose={() => { setOpenDialog(false); setAllowAlumniRegistration(false); }}>
        <DialogTitle>Re-register Alumni?</DialogTitle>
        <DialogContent>
          This NRIC belongs to an alumni student. Are you sure you want to re-register?
        </DialogContent>
        <DialogActions>
          <Button onClick={() => { setOpenDialog(false); setAllowAlumniRegistration(false); }}>Cancel</Button>
          <Button onClick={deleteAlumniRegistration} color="primary">Yes, Register</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

const NewStudenth = ({ onFormSubmit }) => {
  return (
    <div>
      <NewStudent onFormSubmit={onFormSubmit} />
    </div>
  );
};

export default NewStudenth;